import IFaturaUsina from "../interfaces/IFaturaUsina";
import IPayload from "../interfaces/IPayload";
import { ToQueryString } from "../utils/utils";
import api from "./api";
import { resources } from "./resources";
class FaturaUsinaService {
    async getById(id: string) {
        return await api.get<IFaturaUsina>(`${resources.faturaUsina}/GetById/${id}`);
    }

    async create(data: any) {
        return await api.post<IFaturaUsina>(`${resources.faturaUsina}/Create`, data);
    }

    async update(data: any) {
        return await api.put<any>(`${resources.faturaUsina}/Update`, data);
    }

    async delete(id: any) {
        return await api.delete<any>(`${resources.faturaUsina}/Delete/${id}`);
    }

    async getWithFilter(filters: any) {
        return await api.get<IPayload>(`${resources.faturaUsina}/GetWithFilter/${ToQueryString(filters)}`);
    }

    async approve(id: any) {
        return await api.put<any>(`${resources.faturaUsina}/Approve/${id}`);
    }

    async charge(data: any) {
        return await api.post<IFaturaUsina>(`${resources.faturaUsina}/Charge`, data);
    }

    async finalize(id: any) {
        return await api.put<any>(`${resources.faturaUsina}/Finalize/${id}`);
    }
}

export default new FaturaUsinaService();
